<template>
    <v-select v-model="amount" v-bind="{ items, disabled }" outlined hide-details dense />
</template>

<script>
import { BID_UNIT_POLICIES } from "@/assets/variables";
import { getPriceUnit } from "@/plugins/getPriceUnit";
BID_UNIT_POLICIES;
export default {
    props: {
        test: { type: Function, default: () => true },
        from: { type: Number, default: 0 },
        unit: { type: Number, default: 0 },
        value: { type: Number, default: 0 },
        current: { type: Number, default: 0 },
        disabled: { type: Boolean, default: false },
        optional: { type: Boolean, default: false },
    },
    data: () => ({
        amount: 0,
    }),
    computed: {
        prices() {
            const from = this.current ? this.current + this.unit : this.from;
            const items = [from];
            do {
                const before = items[items.length - 1];
                items.push(before + getPriceUnit(before));
            } while (items.length < 20);
            return items.map((value) => ({ text: value?.format?.(), value, disabled: !this.test(value) }));
        },
        items() {
            if (this.optional) return [{ text: "선택", value: null }].concat(this.prices);
            else return this.prices;
        },
    },
    mounted() {
        this.amount = this.value;
    },
    watch: {
        value() {
            if (this.amount !== this.value) this.amount = this.value;
        },
        amount() {
            if (this.amount !== this.value) this.$emit("input", this.amount);
        },
    },
    methods: {},
};
</script>

<style></style>
